import axios from "../../axios";
import { ResponseModel } from "../../models/network/response_model";

import { GET_STAFF_LIST } from "./staffTypes"
import { LIST_ALL } from "./staffUrls"

export default {
  [GET_STAFF_LIST]({ commit }, params) {
    axios.get(LIST_ALL, {
      params: params
    }).then((response) => {
      let responseModel = new ResponseModel(response);
      commit(GET_STAFF_LIST, responseModel.result.data)
    });
  },
}
